import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
  name: 'iconName',
})
export class IconName implements PipeTransform {
  transform(element: any): string {
    if (element.file_name == undefined) {
      return 'doc';
    }
    let type = element.file_name.replace(/^.*\./, '') != element.file_name ? element.file_name.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }
}
